import * as _ from 'lodash';
import DecimalForGlobals from '../impuestos/DecimalForGlobals';

class PagosTotalesCalculator {
  data = {};

  constructor(data) {
    this.data = _.cloneDeep(data);
  }

  apply() {
    let totales = {};
    let MontoTotalPagos = 0;
    let pagos = this.data || [];

    for (const pago of pagos) {
      MontoTotalPagos += parseFloat(pago.Monto ?? 0) * (pago.TipoCambioP || 1);

      let traslados = _.get(pago, 'ImpuestosP.TrasladosP.TrasladoP') || [];

      for (const traslado of traslados) {
        if (traslado.TasaOCuotaP === '0.160000') {
          totales.TotalTrasladosBaseIVA16 = parseFloat(
            (totales.TotalTrasladosBaseIVA16 ?? 0) + this._calculteBaseP(pago, traslado)
          );
          totales.TotalTrasladosImpuestoIVA16 = parseFloat(
            (totales.TotalTrasladosImpuestoIVA16 ?? 0) + this._calculteImporteP(pago, traslado)
          );
        } else if (traslado.TasaOCuotaP === '0.080000') {
          totales.TotalTrasladosBaseIVA8 = parseFloat(
            (totales.TotalTrasladosBaseIVA8 ?? 0) + this._calculteBaseP(pago, traslado)
          );
          totales.TotalTrasladosImpuestoIVA8 = parseFloat(
            (totales.TotalTrasladosImpuestoIVA8 ?? 0) + this._calculteImporteP(pago, traslado)
          );
        } else if (traslado.TasaOCuotaP <= 0) {
          totales.TotalTrasladosBaseIVA0 = parseFloat(
            (totales.TotalTrasladosBaseIVA0 ?? 0) + this._calculteBaseP(pago, traslado)
          );
          totales.TotalTrasladosImpuestoIVA0 = parseFloat(
            (totales.TotalTrasladosImpuestoIVA0 ?? 0) + this._calculteImporteP(pago, traslado)
          );
        } else if (traslado.TipoFactorP === 'Exento') {
          totales.TotalTrasladosBaseIVAExento = parseFloat(
            (totales.TotalTrasladosBaseIVAExento ?? 0) + this._calculteBaseP(pago, traslado)
          );
        }
      }

      let retenciones = _.get(pago, 'ImpuestosP.RetencionesP.RetencionP') || [];

      for (const retencion of retenciones) {
        if (retencion.ImpuestoP === '001') {
          totales.TotalRetencionesISR = parseFloat(
            (totales.TotalRetencionesISR ?? 0) + this._calculteImporteP(pago, retencion)
          );
        } else if (retencion.ImpuestoP === '002') {
          totales.TotalRetencionesIVA = parseFloat(
            (totales.TotalRetencionesIVA ?? 0) + this._calculteImporteP(pago, retencion)
          );
        } else if (retencion.ImpuestoP === '003') {
          totales.TotalRetencionesIEPS = parseFloat(
            (totales.TotalRetencionesIEPS ?? 0) + this._calculteImporteP(pago, retencion)
          );
        }
      }
    }

    for (const key of Object.keys(totales)) {
      totales[key] = DecimalForGlobals.make(totales[key]).toFixed();
    }

    if (MontoTotalPagos > 0) {
      totales.MontoTotalPagos = DecimalForGlobals.make(MontoTotalPagos).toFixed();
    }

    return {
      ...totales,
    };
  }

  _calculteBaseP(pago, impuesto) {
    return parseFloat((impuesto.BaseP || 0) * (pago.TipoCambioP || 1));
  }

  _calculteImporteP(pago, impuesto) {
    return parseFloat((impuesto.ImporteP || 0) * (pago.TipoCambioP || 1));
  }
}

export default PagosTotalesCalculator;
